import styles from "./style.module.css";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import StartFooter from "../../../components/Common/StartFooter"
import mainContext from "../../../context/mainContext";
import dataContext from "../../../context/dataContext";

import earphonesImg from "../../../assets/images/icons/FrameHeadPhone.png"
import src from '../../../assets/images/illustrations/head-phones.svg'

function PushUpInstructions() {
  const { header } = useContext(mainContext)
  const { userDetails } = useContext(dataContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [sortedTR, setSortedTR] = useState(userDetails.TR.length > 0 ? userDetails.TR.sort((a, b) => new Date(a.date) - new Date(b.date)) : [])

  useEffect(() => {
    header.setPageName(`PUSHUP Round ${navigateObject.roundCounter}/4, INSTRUCTION`);
    return () => header.setPageName(``);
  }, [])

  const navigateObject = !location.state.navigateObject ? {
    bookName: location.state.bookName,
    newBook: location.state.newBook,
    genre: location.state.genre,
    Bpage: location.state.Bpage,
    Epage: location.state.Epage,
    roundCounter: 1,
    lpm: sortedTR.length > 0 ? location.state.chosenLpm ? location.state.chosenLpm : location.state.newBook ? sortedTR[sortedTR.length - 1]?.value * 0.80 : sortedTR[sortedTR.length - 1]?.value : 30,// TODO: need to be conect to WPMfoirst results not 10 by default
    rateData: {
      LPM: 0,
      newLPM: 0,
      round: 0,
      justRight: false
    },
    questions: []
  } : location.state.navigateObject;

  const book = navigateObject.bookName;

  console.log("🚀 ~ PushUpInstructions ~ navigateObject:", navigateObject)

  const instructionsText = navigateObject?.roundCounter === 4
    ? (`read only until it FIRST FEELS FAST, then press stop.`)
    : navigateObject?.roundCounter === 1
      ? (`With your headphones on, start reading, while using your LEFT index finger only to follow, at the pace of the the left-to-right, right-to-left stereo sound. Continue for 3 minutes until the sound stops.`)
      : "Continue reading from where you stopped, for another 3 minutes. When you are ready to read, press the START NOW button."

  const startRound = () => navigate("/train-reading/timer", { state: { navigateObject } });


  return (
    <div className="pages">
      <div className={styles.centerImg}>
        <img src={src} id="headphones" alt="headphones" className={styles.headphones} />
      </div>
      <div id="playDiv">
        <StartFooter
          startFunction={() => startRound()}
          title="Start Now"
          subtitle={navigateObject?.roundCounter == 1 ? "With your headphones on," : navigateObject?.roundCounter == 4 ? "This time," : ""}
          explanation={instructionsText}
          img={earphonesImg}
        />
      </div>
    </div>
  );
}

export default PushUpInstructions;